import Activity from './Activity';

export default class ActivityForm {
  constructor(id = null, name = '', description = null, video = null, image = null, audio = null, external_link = null, activity_type = null, primaryStatus = null, statuses = []) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.video = video;
    this.image = image;
    this.audio = audio;
    this.external_link = external_link;
    this.activity_type = activity_type;
    this.primaryStatus = primaryStatus;
    this.statuses = statuses;
  }

  formatforDB() {
    const data = {
      id: this.id,
      name: this.name,
      description: this.description,
      video: this.video ? this.video.id : null,
      image: this.image ? this.image.id : null,
      audio: this.audio ? this.audio.id : null,
      external_link: this.external_link,
      external_link_description: this.external_link_description,
      activity_type: this.activity_type,
      publishable: this.publishable,
    }

    return new Activity(
      data.id,
      data.name,
      data.description,
      data.video,
      data.image,
      data.audio,
      data.external_link,
      data.external_link_description,
      data.activity_type,
    );
  }

  formatForForm(obj, props) {
    const activity = new Activity();
    if (obj) {
      for (const key in activity) {
        if (obj.hasOwnProperty(key)) {
          activity[key] = obj[key];
        }
      }
    }

    this.id = activity.id;
    this.name = activity.name;
    this.description = activity.description || "";
    this.video = activity.video;
    this.image = activity.image;
    this.audio = activity.audio;
    this.audio_description = activity.audio  && activity.audio.description ? activity.audio.description : "";
    this.external_link = activity.external_link  && activity.external_link.link ? activity.external_link.link : "";
    this.external_link_description = activity.external_link && activity.external_link.description ? activity.external_link.description : "";
    this.activity_type = activity.activity_type;
    this.publishable = activity.publishable;
    
    this.checkValidity(props);
  }

  checkValidity(props) {
    let primaryStatus = 'Valid';
    let statusList = {};

    const nameText = 'Activity name';
    //const videoText = 'Uploaded a demonstration video which visually demonstrates the exercise with correct form';

    if (this.name !== '') {
      statusList.name = {value: true, text: nameText};
    }
    else {
      primaryStatus = 'Invalid';
      statusList.name = {value: false, text: nameText};
    }

    this.primaryStatus = primaryStatus;
    this.statuses = statusList;
  }
}
